import React from "react";
import "./Offers_Slider.css";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Offers_Slider() {
  const data = [
    "/assets/images/offer_slider/img1.png",
    "/assets/images/offer_slider/img2.png",
    "/assets/images/offer_slider/img1.png",
  ];

  return (
    <section className="Offers_Slider">
      <div className="">
        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          modules={[Pagination]}
          autoplay={{ delay: 300 }}
          className="common_swiper"
          breakpoints={{
            0: {
              slidesPerView: 1.1,
            },
            600: {
              slidesPerView: 2,
            },
          }}
        >
          {data?.length > 0 &&
            data?.map((item) => {
              return (
                <SwiperSlide>
                  <div className="img_holder">
                    <img src={process.env.PUBLIC_URL + item} className="image" />
                  </div>
                </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
    </section>
  );
}

export default Offers_Slider;
